<template>
    <div>
        <section class="shift-tbl-data-sec">
            <table v-if="newFormattedShiftWiseAssignment.length" class="monthly-sch-tbl w-full custom-shift-tbl">
                <tbody>
                    <tr v-for="(shift, shiftIndex) in newFormattedShiftWiseAssignment" :key="('employee-index' + shiftIndex)">
                        <td class="month-td-left">
                            <div class="month-td-data-left flex items-center justify-between px-2 left-tbl-col">
                                <span class="text-ellipsis-style">{{ shift.name }}</span>
                                <span v-if="shift.start_time || shift.start_time" class="text-black font-semibold"> 
                                    {{ convertTime(shift.start_time.substring(0,5)) + ' - ' + convertTime(shift.end_time.substring(0,5))  }} 
                                </span>
                            </div>
                        </td>
                        <td v-for="(s_assignment, s_assignment_index) in shift.all_shift_assignment" :key="('shift-assignment-' + s_assignment_index)"
                            :style="{ width: ((100 - 14) / shift.all_shift_assignment.length) + '%' }"
                            class="text-center month-td-right">
                            <div class="month-td-data-right" :class="getShiftAssClass(s_assignment.against_deficit, s_assignment.is_excess)">
                                <span v-if="s_assignment.assigned_count">
                                    {{ s_assignment.assigned_count  }}
                                </span>
                                <span v-else> 0 </span>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <!-- If data is NA -->
            <el-empty v-else description="Something went wrong...">
                <BaseButton @click="$emit('getAllMonthData')" style="width: 110px;  margin-right:15px;" size="medium"
                    type="submit" buttonclass="btn p-2 text-xs ">
                    Retry
                </BaseButton>
            </el-empty>
        </section>
    </div>
</template>

<script>
export default {
    name: "MonthlyShiftWiseAssignmentTable",
    props: {
        formattedShiftWiseAssignment: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            
        }
    },
    computed: {
        newFormattedShiftWiseAssignment() {
            return this.formattedShiftWiseAssignment;
        }
    },
    methods: {
        getShiftAssClass(against_deficit, is_excess){
            var data = null;
            data = (against_deficit >= 1) ? 'bg-red-lighter' : (is_excess >= 1) ? 'bg-green-yellow' : ''
            return data;
        },
        convertTime(time) {
            // Check correct time format and split into components
            time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

            if (time.length > 1) { // If time format correct
                time = time.slice(1);  // Remove full string match value
                time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
                time[0] = +time[0] % 12 || 12; // Adjust hours
            }
            return time.join(''); // return adjusted time or original string
        }
    },
}
</script>

<style lang="scss" scoped>
     .excess-data-bg{
        background-color: rgb(242, 204, 90);
    }
    .deficit-data-bg{
        background-color: rgb(241, 130, 86);
    }
</style>


<style lang="scss">
    @import './MonthlyScheduler.scss';
</style>
